import React from 'react';
import styled from 'styled-components';
import Spinner from 'components/atoms/Loading/Spinner';

const Centered = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
`;

const LoadingPage = ({ text, ...rest }) => {
    return (
        <Centered {...rest}>
            <Spinner text={text} />
        </Centered>
    );
};

export default LoadingPage;
